const warningRE = new RegExp("%WARN-EINVAL:\\s(.*)");
export const handleWarnings = (input) => {
  const match = input.match(warningRE);
  if (match !== null) {
    const [_all, message] = match;
    throw message;
  }
  return input;
};
